export default __webpack_public_path__ + "static/media/kitch.b28cd01a.mp3";